module.exports = __webpack_public_path__ + "img/area_4.7dc22a54.png";